export default __webpack_public_path__ + "static/media/Elio zone.662c3191.jpg";